type Props = {
    docsImagesList: () => any
}
const ViewDocuments = ({docsImagesList} : Props) => {
    return <div className='row'>
        {docsImagesList()}
    </div>
}

export default ViewDocuments